const enginebrands = [
  { text: 'option.enginebrand.001', value: 'Alamarin Jet' },
  { text: 'option.enginebrand.002', value: 'Alona' },
  { text: 'option.enginebrand.003', value: 'Archimedes' },
  { text: 'option.enginebrand.004', value: 'Arona' },
  { text: 'option.enginebrand.005', value: 'Bedford' },
  { text: 'option.enginebrand.006', value: 'Betamarine' },
  { text: 'option.enginebrand.007', value: 'Bmw' },
  { text: 'option.enginebrand.008', value: 'Bombardier-Rotax' },
  { text: 'option.enginebrand.009', value: 'Bukh' },
  { text: 'option.enginebrand.010', value: 'Castoldi Jet' },
  { text: 'option.enginebrand.011', value: 'Caterpillar' },
  { text: 'option.enginebrand.012', value: 'Chevrolet' },
  { text: 'option.enginebrand.013', value: 'Chrysler' },
  { text: 'option.enginebrand.014', value: 'Crusader' },
  { text: 'option.enginebrand.015', value: 'Cummins' },
  { text: 'option.enginebrand.016', value: 'Cummins Industrial' },
  { text: 'option.enginebrand.017', value: 'Detroit Diesel' },
  { text: 'option.enginebrand.018', value: 'Deutz' },
  { text: 'option.enginebrand.019', value: 'Deutz Marine' },
  { text: 'option.enginebrand.020', value: 'Ekström' },
  { text: 'option.enginebrand.021', value: 'Evinrude' },
  { text: 'option.enginebrand.022', value: 'Ford' },
  { text: 'option.enginebrand.023', value: 'Ford Power' },
  { text: 'option.enginebrand.024', value: 'Hamilton Jet' },
  { text: 'option.enginebrand.025', value: 'Hanomag' },
  { text: 'option.enginebrand.026', value: 'Honda' },
  { text: 'option.enginebrand.027', value: 'Industrial-Ford' },
  { text: 'option.enginebrand.028', value: 'Iveco' },
  { text: 'option.enginebrand.029', value: 'Iveco Aifo' },
  { text: 'option.enginebrand.030', value: 'Johnson' },
  { text: 'option.enginebrand.031', value: 'Kawasaki' },
  { text: 'option.enginebrand.032', value: 'Kubota Beta Marine' },
  { text: 'option.enginebrand.033', value: 'Kubota Nanni' },
  { text: 'option.enginebrand.034', value: 'Kubota Nanni Marine' },
  { text: 'option.enginebrand.035', value: 'Leyland' },
  { text: 'option.enginebrand.036', value: 'Lister' },
  { text: 'option.enginebrand.037', value: 'Lombardini' },
  { text: 'option.enginebrand.038', value: 'MAN' },
  { text: 'option.enginebrand.039', value: 'Mariner' },
  { text: 'option.enginebrand.040', value: 'Mariner Power' },
  { text: 'option.enginebrand.041', value: 'Mercedez-Benz' },
  { text: 'option.enginebrand.042', value: 'MerCruiser' },
  { text: 'option.enginebrand.043', value: 'Mercury' },
  { text: 'option.enginebrand.044', value: 'Mitsubishi' },
  { text: 'option.enginebrand.045', value: 'Monark' },
  { text: 'option.enginebrand.046', value: 'Motor' },
  { text: 'option.enginebrand.047', value: 'MTU' },
  { text: 'option.enginebrand.048', value: 'Najad 340' },
  { text: 'option.enginebrand.049', value: 'Nissan' },
  { text: 'option.enginebrand.050', value: 'Olympia' },
  { text: 'option.enginebrand.051', value: 'OMC' },
  { text: 'option.enginebrand.052', value: 'OMC Cobra Diesel' },
  { text: 'option.enginebrand.053', value: 'OMC-Cobra' },
  { text: 'option.enginebrand.054', value: 'OMC-King Cobra' },
  { text: 'option.enginebrand.055', value: 'Peninsular' },
  { text: 'option.enginebrand.056', value: 'Perkins' },
  { text: 'option.enginebrand.057', value: 'Rotax' },
  { text: 'option.enginebrand.058', value: 'Ruggesriine' },
  { text: 'option.enginebrand.059', value: 'Sabre Lehman' },
  { text: 'option.enginebrand.060', value: 'Scania' },
  { text: 'option.enginebrand.061', value: 'Seagull' },
  { text: 'option.enginebrand.062', value: 'Seatoy-Toyota' },
  { text: 'option.enginebrand.063', value: 'Selva' },
  { text: 'option.enginebrand.064', value: 'Sole Diesel' },
  { text: 'option.enginebrand.065', value: 'Status' },
  { text: 'option.enginebrand.066', value: 'Suzuki' },
  { text: 'option.enginebrand.067', value: 'Tamdee' },
  { text: 'option.enginebrand.068', value: 'Tohatsu' },
  { text: 'option.enginebrand.069', value: 'Toyota' },
  { text: 'option.enginebrand.070', value: 'Valmet' },
  { text: 'option.enginebrand.071', value: 'Vetus' },
  { text: 'option.enginebrand.072', value: 'Vetus Deutz' },
  { text: 'option.enginebrand.073', value: 'Vire' },
  { text: 'option.enginebrand.074', value: 'Volvo Penta' },
  { text: 'option.enginebrand.075', value: 'Westerbeke' },
  { text: 'option.enginebrand.076', value: 'Wickström' },
  { text: 'option.enginebrand.077', value: 'Yamaha' },
  { text: 'option.enginebrand.078', value: 'Yanmar' },
];

export default enginebrands;
